import { clientConfig, type LanguageKey } from "./client";
import { env } from "./env";

export const i18n = {
  default: env.NEXT_PUBLIC_I18N as LanguageKey,
  locales: clientConfig[env.CLIENT]?.locales ?? [],
  localesTemplateConfig: clientConfig,
} satisfies {
  default: LanguageKey;
  locales: readonly string[];
  localesTemplateConfig: typeof clientConfig;
};

export const indexes: { name: string; language: string }[] = [
  { name: env.NEXT_PUBLIC_INDEX_ENGLISH, language: "en" },
  { name: env.NEXT_PUBLIC_INDEX_GERMAN, language: "de" },
  { name: env.NEXT_PUBLIC_INDEX_HUNGARIAN, language: "hu" },
  { name: env.NEXT_PUBLIC_INDEX_SWEDISH, language: "sv" },
  { name: env.NEXT_PUBLIC_INDEX_TCHECH, language: "cs" },
  { name: env.NEXT_PUBLIC_INDEX_ROMANIAN, language: "ro" },
];
